import React, { useEffect, useMemo } from 'react'

import {
  Button,
  Icon,
  Close,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  func, bool, node, string,
} from 'prop-types'

import FocusTrapContext from 'Utils/FocusTrapContext'
import useEscapeKeyHandler from 'Utils/useEscapeKeyHandler'
import useFocusTrap from 'Utils/useFocusTrap'

function Sidebar({
  isOpen,
  closeSidebar,
  children,
  title,
  className = '',
}) {
  useEscapeKeyHandler(closeSidebar)
  const { trapRef, registerAlly } = useFocusTrap(isOpen)
  const focusTrapContextValue = useMemo(() => ({ registerAlly }), [registerAlly])

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : ''

    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  if (!isOpen) {
    return null
  }

  const titleId = `sidebar-title-${Math.random().toString(36).substr(2, 9)}`

  const handleBackdropKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      closeSidebar()
    }
  }

  return (
    <>
      <div
        className="shared-sidebar__backdrop"
        onClick={closeSidebar}
        onKeyDown={handleBackdropKeyDown}
        role="presentation"
        tabIndex="-1"
      />
      <div
        ref={trapRef}
        className={classnames('shared-sidebar', className)}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <div className="shared-sidebar__container">
          <div className="shared-sidebar__header">
            <h3 id={titleId} className="shared-sidebar__title">{title}</h3>
            <div className="shared-sidebar__close-button-container">
              <Button
                size="small"
                type="ghost"
                variant="only-icon"
                onClick={closeSidebar}
                customClass="shared-sidebar__close-button"
                icon={<Icon svgComponent={Close} />}
                aria-label={`Close ${title} sidebar`}
              />
            </div>
          </div>
          <div className="shared-sidebar__content" role="document">
            <FocusTrapContext.Provider value={focusTrapContextValue}>
              {children}
            </FocusTrapContext.Provider>
          </div>
        </div>
      </div>
    </>
  )
}

Sidebar.propTypes = {
  isOpen: bool.isRequired,
  closeSidebar: func.isRequired,
  children: node.isRequired,
  title: string.isRequired,
  className: string,
}

export default Sidebar
